(function () {
  'use strict';

  var routes = window.theme.routes;

  function formatMoney(cents) {
    var format = window.theme.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    return format.replace(/\{\{\s*amount\s*\}\}/, value).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }
  window.theme.formatMoney = formatMoney;

  /* ---------- Reveal on scroll ---------- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });

  /* ---------- Mobile menu ---------- */
  var mobileMenu = document.getElementById('MobileMenu');
  document.querySelectorAll('[data-menu-open]').forEach(function (btn) {
    btn.addEventListener('click', function () { mobileMenu && mobileMenu.classList.add('open'); });
  });
  document.querySelectorAll('[data-menu-close]').forEach(function (btn) {
    btn.addEventListener('click', function () { mobileMenu && mobileMenu.classList.remove('open'); });
  });
  if (mobileMenu) {
    mobileMenu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { mobileMenu.classList.remove('open'); });
    });
  }

  /* ---------- Cart drawer ---------- */
  function openDrawer() { document.body.classList.add('cart-open'); }
  function closeDrawer() { document.body.classList.remove('cart-open'); }
  window.theme.openDrawer = openDrawer;

  document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', closeDrawer);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  function updateCounts(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
  }

  function renderCart(cart) {
    updateCounts(cart.item_count);
    var itemsEl = document.querySelector('[data-drawer-items]');
    var footEl = document.querySelector('[data-drawer-foot]');
    if (!itemsEl) return;
    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="cart-drawer__empty">' + itemsEl.getAttribute('data-empty-text') + '</div>';
      if (footEl) footEl.style.display = 'none';
      return;
    }
    if (footEl) footEl.style.display = '';
    var subtotalEl = document.querySelector('[data-drawer-subtotal]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price);
    itemsEl.innerHTML = cart.items.map(function (item) {
      var img = item.image
        ? '<img class="cart-line__img" src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_160x$1$2') + '" alt="" loading="lazy">'
        : '<div class="cart-line__img"></div>';
      var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      return (
        '<div class="cart-line" data-line-key="' + item.key + '">' +
          img +
          '<div class="cart-line__body">' +
            '<a class="cart-line__title" href="' + item.url + '">' + item.product_title + '</a>' +
            '<div class="cart-line__meta">' + (item.vendor || '') + (variantTitle ? ' | ' + variantTitle : '') + '</div>' +
            '<div class="cart-line__price">' + formatMoney(item.final_line_price) + '</div>' +
            '<div class="cart-line__controls">' +
              '<div class="qty-box">' +
                '<button type="button" data-qty-change="-1" aria-label="Decrease quantity">&minus;</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-qty-change="1" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<button type="button" class="cart-line__remove" data-line-remove>' + itemsEl.getAttribute('data-remove-text') + '</button>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');
  }

  function fetchCart() {
    return fetch(routes.cartUrl).then(function (r) { return r.json(); }).then(function (cart) {
      renderCart(cart);
      return cart;
    });
  }
  window.theme.fetchCart = fetchCart;

  function changeLine(key, quantity) {
    return fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-qty-change]');
    var removeBtn = e.target.closest('[data-line-remove]');
    var line = e.target.closest('[data-line-key]');
    if (!line) return;
    var key = line.getAttribute('data-line-key');
    if (qtyBtn) {
      var current = parseInt(line.querySelector('.qty-box span').textContent, 10);
      changeLine(key, Math.max(0, current + parseInt(qtyBtn.getAttribute('data-qty-change'), 10)));
    } else if (removeBtn) {
      changeLine(key, 0);
    }
  });

  function addItems(items) {
    return fetch(routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    }).then(function () {
      return fetchCart().then(function (cart) {
        openDrawer();
        return cart;
      });
    });
  }
  window.theme.addItems = addItems;

  /* AJAX intercept for product forms and quick add */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]').value;
    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    addItems([{ id: parseInt(id, 10), quantity: qty }])
      .catch(function () { window.location.href = form.getAttribute('action') || routes.cart; })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  /* ---------- Product gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.src = thumb.getAttribute('data-src');
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  });

  /* ---------- Facet dropdowns: close others ---------- */
  document.querySelectorAll('.facet').forEach(function (facet) {
    facet.addEventListener('toggle', function () {
      if (facet.open) {
        document.querySelectorAll('.facet[open]').forEach(function (other) {
          if (other !== facet) other.removeAttribute('open');
        });
      }
    });
  });

  fetchCart();
})();
